export function getApiBase() {
  return process.env.REACT_APP_API_URL;
}

export function getRecomApiBase() {
  return "http://localhost:8000";
}

export function getWsBase() {
  const base = process.env.REACT_APP_API_URL || "";
  return base.replace(/^https/, "wss").replace(/^http/, "ws");
}